import { FormattedMessage, FormattedNumber } from 'react-intl'

import { Typography } from '@gto/ui/typography'

import { FlipOutsRules } from '@/pages/promotion/components/flip-outs/flip-outs-rules'
import { FlipOutsSection } from '@/pages/promotion/components/flip-outs/flip-outs-section'

export const AllInFlipOutsRoute = () => {
  return (
    <div className="flex flex-col gap-10">
      <Typography variant="h4">
        <FormattedMessage
          id="promo.allInFlipOuts.title"
          values={{
            prize: (
              <FormattedNumber
                currency="USD"
                minimumFractionDigits={0}
                style="currency"
                value={10_000}
              />
            ),
          }}
        />
      </Typography>
      <FlipOutsSection />
      <FlipOutsRules />
    </div>
  )
}
